module.exports = {
      id: "shareblueicon-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-8d9b573d9b90f77b99b1f4ba3311a2ef.svg#shareblueicon",
      toString: function () {
        return this.url;
      }
    }